import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Check } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const startCheckout = async (lookupKey, courseId, user, navigate) => {
  if (!user) {
    navigate("/auth");
    return;
  }
  try {
    const { data } = await api.post("/payments/checkout", {
      lookup_key: lookupKey,
      origin_url: window.location.origin,
      course_id: courseId || null,
    });
    window.location.href = data.checkout_url;
  } catch {
    toast.error("Erreur lors de la création du paiement");
  }
};

export const PricingSection = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();

  const plans = [
    { key: "free", name: t("pricing.free"), price: "0 $", desc: t("pricing.freeDesc"), cta: t("pricing.freeBtn"), action: () => navigate("/parcours"), testid: "pricing-free" },
    { key: "unit", name: t("pricing.unit"), price: "29 $", desc: t("pricing.unitDesc"), cta: t("pricing.buy"), action: () => navigate("/parcours"), testid: "pricing-unit" },
    { key: "level", name: t("pricing.level"), price: "149 $", desc: t("pricing.levelDesc"), cta: t("pricing.buy"), action: () => startCheckout("level_1_full", null, user, navigate), featured: true, testid: "pricing-level" },
    { key: "sub", name: t("pricing.sub"), price: "24 $", suffix: t("pricing.month"), desc: t("pricing.subDesc"), cta: t("pricing.buy"), action: () => startCheckout("subscription_monthly", null, user, navigate), testid: "pricing-sub" },
  ];

  return (
    <section className="max-w-7xl mx-auto px-6 py-24" data-testid="pricing-section">
      <h2 className="text-3xl sm:text-4xl font-serif-display tracking-tight mb-12">{t("pricing.title")}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {plans.map((p) => (
          <div key={p.key} className={`card-lift rounded-lg border p-7 flex flex-col ${p.featured ? "border-primary/50 bg-primary/5" : "border-primary/15 bg-card"}`} data-testid={p.testid}>
            <p className="text-xs uppercase tracking-[0.2em] text-primary/80">{p.name}</p>
            <p className="mt-4 flex items-baseline gap-1">
              <span className="font-serif-display text-4xl text-foreground">{p.price}</span>
              <span className="text-sm text-muted-foreground">CAD{p.suffix || ""}</span>
            </p>
            <p className="text-sm text-foreground/65 mt-4 leading-relaxed flex-1">{p.desc}</p>
            <button onClick={p.action}
              className={`mt-7 py-2.5 rounded-full text-sm font-medium transition-colors duration-200 ${p.featured ? "bg-primary text-primary-foreground hover:bg-[#16528A]" : "border border-primary/40 text-primary hover:bg-primary/10"}`}
              data-testid={`${p.testid}-btn`}>
              {p.cta}
            </button>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-6 flex items-center gap-2"><Check size={13} className="text-primary" /> Paiement sécurisé par Stripe · Carte de test : 4242 4242 4242 4242</p>
    </section>
  );
};
